import "./styleLogin.css";
import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";

import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";

const Login = () => {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { user, login: authLogin } = useAuth();

  const navigate = useNavigate();

  // Redireciona se já estiver logado
  useEffect(() => {
    if (user) {
      navigate("/painel");
    }
  }, [user, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username: login,
            password: password,
          }),
        },
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Erro ao fazer login");
      }

      if (data.success) {
        const userData = {
          token: data.token,
          id: data.user.id,
          username: data.user.username,
          nome: data.user.nome,
          email: data.user.email,
          tipo: data.user.tipo,
          modulos: data.user.modulos,
          roles: data.user.roles || ["user"],
        };

        authLogin(userData);
        navigate("/painel");
      } else {
        alert(data.message || "Usuário ou senha inválidos");
      }
    } catch (error) {
      console.error("Erro ao fazer login:", error);
      alert(error.message || "Erro ao fazer login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end", // Alinha tudo à direita
        backgroundImage: `url(/wp-content/plugins/App/build/login-background.jpg)`,
        backgroundSize: "cover",
        backgroundPosition: "50%",
        backgroundRepeat: "no-repeat",
        position: "relative",
      }}
    >
      {/* Overlay escuro para melhor contraste */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.3)", // Overlay escuro
          zIndex: 1,
        }}
      ></div>

      {/* Container principal */}
      <div
        style={{
          position: "relative",
          zIndex: 2,
          width: "100%",
          maxWidth: "500px",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "2rem",
          backgroundColor: "white",
          boxShadow: "-4px 0 20px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div
          style={{
            width: "90%",
            maxWidth: "400px",
          }}
        >
          {/* LOGO no topo */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "50px",
            }}
          >
            <img
              src="/wp-content/plugins/App/build/Logo.png"
              alt="Logo"
              style={{
                width: "400px",
                height: "auto",
                maxWidth: "100%",
              }}
            />
          </div>

          {/* Formulário */}
          <form onSubmit={handleLogin}>
            {/* Login */}
            <div style={{ marginBottom: "1.5rem" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "0.5rem",
                  color: "#555",
                  fontWeight: "500",
                }}
              >
                Login
              </label>

              <InputText
                type="text"
                value={login}
                onChange={(e) => setLogin(e.target.value)}
                style={{
                  width: "100%",
                  padding: "0.8rem",
                  borderRadius: "8px",
                  border: "1px solid #ddd",
                  fontSize: "1rem",
                  boxSizing: "border-box",
                }}
                placeholder="Digite seu usuário"
                autoComplete="username"
              />
            </div>

            {/* Senha */}
            <div style={{ marginBottom: "1.5rem" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "0.5rem",
                  color: "#555",
                  fontWeight: "500",
                }}
              >
                Senha
              </label>

              <div style={{ position: "relative", margin: "10px 0" }}>
                <InputText
                  type={showPassword ? "text" : "password"}
                  placeholder="Digite sua senha"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{
                    width: "100%",
                    paddingRight: "35px",
                    padding: "0.8rem",
                    borderRadius: "8px",
                    border: "1px solid #ddd",
                    fontSize: "1rem",
                    boxSizing: "border-box",
                  }}
                  autoComplete="current-password"
                />
                <i
                  className={`pi ${showPassword ? "pi-eye-slash" : "pi-eye"}`}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#6c757d",
                  }}
                  onClick={() => setShowPassword(!showPassword)}
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "2.5rem",
              }}
            ></div>

            {/* Botão */}
            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%",
                padding: "0.8rem",
                backgroundColor: loading ? "#999" : "#D0433C",
                color: "white",
                border: "none",
                borderRadius: "8px",
                fontSize: "1rem",
                fontWeight: "600",
                cursor: loading ? "not-allowed" : "pointer",
                marginBottom: "1.5rem",
                transition: "background-color 0.3s",
              }}
              onMouseOver={(e) =>
                !loading && (e.target.style.backgroundColor = "#A6342F")
              }
              onMouseOut={(e) =>
                !loading && (e.target.style.backgroundColor = "#D0433C")
              }
            >
              {loading ? (
                <span>
                  <i
                    className="pi pi-spinner pi-spin"
                    style={{ marginRight: "8px" }}
                  ></i>
                  Entrando...
                </span>
              ) : (
                "Entrar"
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
